<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			width="90%"
			:maxWidth="maxWidthDialog"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center justify-start">
							<v-icon color="warning" class="mr-2">mdi-account-file-outline</v-icon>
							<p class="mb-0 font-weight-bold text-primary body-1">Detalle Solicitud Cliente</p>
						</div>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									dark
									small
									color="#959595"
									@click="$store.commit('userrequests/setUserRequestModalId', null)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon dark>mdi-close</v-icon>
								</v-btn>
							</template>
							<span>Cerrar</span>
						</v-tooltip>
					</div>
				</v-card-title>
				<v-card-text class="pa-0">
					<div class="pa-6" v-if="loadingUserRequest">
						<div class="d-flex flex-column justify-center align-center">
							<v-progress-circular
								:size="50"
								:width="5"
								color="rgba(0,0,0,0.2)"
								class="mb-3"
								indeterminate
							></v-progress-circular>
							Cargando Información
						</div>
					</div>
          <div class="pb-4 px-8" v-else>
						<div class="mt-6" v-if="resolveRequest">
							<!-- <div>
								<v-select
									v-model="resolveForm.status"
									:items="resolveStatuses"
									item-text="text"
									item-value="id"
									label="Tipo de Cierre"
									outlined
									dense
									required
									hide-details
									:rules="requiredRule"
								>
								</v-select>
							</div> -->
							<div>
								<p class="mb-0 caption mt-2">Por favor ingresa un detalle.</p>
								<v-textarea
									v-model="resolveForm.response"
									label="Ingresa el detalle"
									color="#524D4D"
									outlined
									rows="4"
									class="mt-2 w-100"
								></v-textarea>
							</div>
						</div>
						<v-row class="mb-4" v-else>
							<v-col cols="12" md="12">
								<v-card class="mt-6 mb-4">
									<v-card-text class="py-2">
										<div class="d-flex align-center justify-space-between">
											<div class="d-flex align-center justify-space-between" style="width: 100%;">
												<div class="d-flex align-center">
													<p class="font-weight-bold body-2 px-1 mb-0 mr-2">Datos Cliente</p>
												</div>
											</div>
										</div>
										<v-divider class="my-1"></v-divider>
										<div class="my-3" v-if="userInfo">
											<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
												<div style="width: 120px">Nombre</div><span>:</span> <b class="text-end" style="flex: 1;">{{userInfo.profile.name}} {{userInfo.profile.lastname}} {{userInfo.profile.second_lastname}}</b>
											</div>
											<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
												<div style="width: 120px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{userInfo.email}}</b>
											</div>
											<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
												<div style="width: 120px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{userInfo.profile.phone}}</b>
											</div>
										</div>
										<v-divider class="my-2"></v-divider>
										<div class="d-flex align-center justify-space-between">
											<div class="d-flex align-center justify-space-between" style="width: 100%;">
												<div class="d-flex align-center">
													<p class="font-weight-bold body-2 px-1 mb-0 mr-2">Detalle Solicitud</p>
												</div>
											</div>
										</div>
										<v-divider class="my-1"></v-divider>
										<div class="my-3">
											<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
												<div style="width: 120px">Proyecto</div><span>:</span>
												<div class="d-flex flex-column flex-grow-1">
													<b class="text-end" style="flex: 1;">{{ requestProjectName }}</b>
													<p class="text-end caption" style="flex: 1;">{{ requestProjectAddress }}</p>
												</div>
											</div>
											<!-- <div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
												<div style="width: 120px">Tipo de Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{  projectTypeText  }}</b>
											</div> -->
											<v-divider class="my-2"></v-divider>
											<div class="px-1">
												<div class="d-flex justify-space-between align-center">
													<p class="mb-0 font-weight-bold">Descripción</p>
													<v-chip
														v-if="userRequest.request_type == 4"
														color="orange"
														label
														small
														outlined
													>
														<b>Cliente Solicita Anexo de Contrato</b>
													</v-chip>
												</div>
												<div v-if="userRequest?.description" v-html="userRequest.description"></div>
												<div v-else class="text-secondary">El usuario no incluyó una descripción</div>
											</div>
										</div>
									</v-card-text>
								</v-card>
							<!-- </v-col>
							<v-col cols="12" md="5"> -->
								<v-card class="mt-6 mb-4">
									<v-card-text class="py-2" v-if="userRequest.status > 1">
										<div class="d-flex justify-center">
											<div class="d-flex flex-column justify-center">
												<v-icon color="orange" large>mdi-alert-outline</v-icon>
												<p class="mb-0">Esta solicitud ya ha sido cerrada</p>
												<div class="mt-2 text-center">
													<v-chip
														:color="userRequest.status == 2 ? 'green':'red'"
														label
														outlined
													>
														<b>{{userRequest.status == 2 ? 'Aceptado':'Rechazado'}}</b>
													</v-chip>
													<div class="mt-2 d-flex align-center" v-if="userRequest.status == 3">
														<b class="mr-2">Detalle Rechazo:</b>
														<p class="mb-0">{{userRequest.response}}</p>
													</div>
												</div>
											</div>
										</div>
									</v-card-text>
									<v-card-text class="py-2" v-if="false">
										<div class="d-flex align-center justify-space-between">
											<div class="d-flex align-center justify-space-between" style="width: 100%;">
												<div class="d-flex align-center">
													<p class="font-weight-bold body-2 px-1 mb-0 mr-2">¿Que Deseas Crear?</p>
												</div>
											</div>
										</div>
										<v-divider class="my-1"></v-divider>
										<div class="my-3 pa-2 type-container">
											<div class="d-flex flex-row align-center justify-space-between">
												<p class="mb-0 font-weight-bold">CRM / Visita Técnica</p>
												<div>
													<v-tooltip bottom
														v-if="projectLineCrm">
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																outlined
																dark
																x-small
																color="green"
																@click="goToCRM(projectLineCrm.morphable_id)"
																v-bind="attrs"
																v-on="on"
															>
																<p class="mb-0 caption font-weight-bold">Ver Detalle</p>
															</v-btn>
														</template>
														<span>Ir al detalle de este CRM</span>
													</v-tooltip>
													<v-tooltip bottom v-else-if="!atLeastOneElement">
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																outlined
																dark
																x-small
																color="#959595"
																@click="addNewElementToProjectLine('crm')"
																v-bind="attrs"
																v-on="on"
															>
																<p class="mb-0 caption">Habilitar</p>
															</v-btn>
														</template>
														<span>Habilita el CRM en la Línea de Proyectos del cliente</span>
													</v-tooltip>
												</div>
											</div>
											<!-- <div class="mt-2">
												<v-menu offset-y>
													<template #activator="{ on, attrs }">
														<v-btn
															depressed
															dark
															x-small
															block
															color="#959595"
															:disabled="!projectLineCrm"
															v-bind="attrs"
															v-on="on"
														>
															Crear Documento / Visita Técnica
														</v-btn>
													</template>
													<div class="white pa-2 w-100">
														<v-btn
															depressed
															outlined
															small
															block
															class="mb-1"
															@click="editCrmSchedule"
															color="#959595"
														>
															<v-icon dark small>mdi-invoice-clock-outline</v-icon>
															<p class="ml-2 mb-0">Agendar Visita Técnica</p>
														</v-btn>
														<v-btn
															depressed
															outlined
															small
															block
															class="mb-1"
															@click="createReport('crm', projectLineCrm)"
															color="#959595"
														>
															<v-icon dark small>mdi-file-document-outline</v-icon>
															<p class="ml-2 mb-0">Crear Informe</p>
														</v-btn>
														<v-btn
															depressed
															outlined
															small
															block
															@click="createBudget('crm', projectLineCrm)"
															color="#959595"
														>
															<v-icon dark small>mdi-book-outline</v-icon>
															<p class="ml-2 mb-0">Crear Presupuesto</p>
														</v-btn>
													</div>
												</v-menu>
											</div> -->
										</div>
										<div class="my-3 pa-2 type-container">
											<div class="d-flex flex-row align-center justify-space-between">
												<p class="mb-0 font-weight-bold">PreProyecto</p>
												<div>
													<v-tooltip bottom
														v-if="projectLinePreProject">
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																outlined
																dark
																x-small
																color="green"
																@click="goToPreProject(projectLinePreProject.morphable_id)"
																v-bind="attrs"
																v-on="on"
															>
																<p class="mb-0 caption font-weight-bold">Ver Detalle</p>
															</v-btn>
														</template>
														<span>Ir al detalle de este PreProyecto</span>
													</v-tooltip>
													<v-tooltip bottom  v-else-if="!atLeastOneElement">
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																outlined
																dark
																x-small
																color="#959595"
																@click="addNewElementToProjectLine('preproject')"
																v-bind="attrs"
																v-on="on"
															>
																<p class="mb-0 caption">Habilitar</p>
															</v-btn>
														</template>
														<span>Habilita el PreProyecto en la Línea de Proyectos del cliente</span>
													</v-tooltip>
												</div>
											</div>
											<!-- <div class="mt-2">
												<v-menu offset-y>
													<template #activator="{ on, attrs }">
														<v-btn
															depressed
															dark
															x-small
															block
															color="#959595"
															:disabled="!projectLinePreProject"
															v-bind="attrs"
															v-on="on"
														>
															Crear Documento
														</v-btn>
													</template>

													<div class="white pa-2 w-100">
														<v-btn
															depressed
															outlined
															small
															block
															class="mb-1"
															@click="createReport('preproject', projectLinePreProject)"
															color="#959595"
														>
															<v-icon dark small>mdi-file-document-outline</v-icon>
															<p class="ml-2 mb-0">Crear Informe</p>
														</v-btn>
														<v-btn
															depressed
															outlined
															small
															block
															@click="createBudget('preproject', projectLinePreProject)"
															color="#959595"
														>
															<v-icon dark small>mdi-book-outline</v-icon>
															<p class="ml-2 mb-0">Crear Presupuesto</p>
														</v-btn>
													</div>
												</v-menu>
											</div> -->
										</div>
										<div class="my-3 pa-2 type-container">
											<div class="d-flex flex-row align-center justify-space-between">
												<p class="mb-0 font-weight-bold">Proyecto</p>
												<div>
													<v-chip
														v-if="projectLineProject"
														color="green"
														label
														outlined
														x-small
														class="px-1"
													>
														<b>Existente</b>
													</v-chip>
													<v-tooltip bottom  v-else-if="!atLeastOneElement">
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																outlined
																dark
																x-small
																color="#959595"
																@click="addNewElementToProjectLine('project')"
																v-bind="attrs"
																v-on="on"
															>
																<p class="mb-0 caption">Habilitar</p>
															</v-btn>
														</template>
														<span>Habilita el Proyecto en la Línea de Proyectos del cliente</span>
													</v-tooltip>
												</div>
											</div>
											<!-- <div class="mt-2">
												<v-menu offset-y>
													<template #activator="{ on, attrs }">
														<v-btn
															depressed
															dark
															x-small
															block
															color="#959595"
															:disabled="!projectLineProject"
															v-bind="attrs"
															v-on="on"
														>
															Crear Documento
														</v-btn>
													</template>

													<div class="white pa-2 w-100">
														<v-btn
															depressed
															outlined
															small
															block
															class="mb-1"
															@click="createReport('project', projectLineProject)"
															color="#959595"
														>
															<v-icon dark small>mdi-file-document-outline</v-icon>
															<p class="ml-2 mb-0">Crear Informe</p>
														</v-btn>
														<v-btn
															depressed
															outlined
															small
															block
															class="mb-1"
															@click="createBudget('project', projectLineProject)"
															color="#959595"
														>
															<v-icon dark small>mdi-book-outline</v-icon>
															<p class="ml-2 mb-0">Crear Presupuesto</p>
														</v-btn>
														<v-btn
															depressed
															outlined
															small
															block
															class="mb-1"
															@click="createContract('project', projectLineProject)"
															color="#959595"
														>
															<v-icon dark small>mdi-briefcase-outline</v-icon>
															<p class="ml-2 mb-0">Crear Contrato</p>
														</v-btn>
														<v-btn
															depressed
															outlined
															small
															block
															@click="createContractAddendum"
															color="#959595"
														>
															<v-icon dark small>mdi-briefcase-plus-outline</v-icon>
															<p class="ml-2 mb-0">Crear Anexo de Contrato</p>
														</v-btn>
													</div>
												</v-menu>
											</div> -->
										</div>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
						<div class="mt-2" v-if="!isClient">
							<div class="d-flex flex-row align-center justify-end"
								v-if="userRequest.status > 1">
								<v-btn
									depressed
									dark
									outlined
									v-if="associatedCrm && userRequest.status == 2"
									color="#959595"
									class="mr-3"
									@click="goToCRM(associatedCrm.morphable_id)"
								>
									<v-icon dark>mdi-contacts-outline</v-icon>
									<p class="ml-2 mb-0">Ver CRM</p>
								</v-btn>
								<v-btn
									depressed
									dark
									outlined
									color="#959595"
									class="mr-3"
									@click="$store.commit('userrequests/setUserRequestModalId', null)"
								>
									<v-icon dark>mdi-close</v-icon>
									<p class="ml-2 mb-0">Cancelar</p>
								</v-btn>
							</div>
							<div class="d-flex flex-row align-center justify-end"
									v-else-if="resolveRequest">
								<v-btn
									depressed
									dark
									outlined
									color="#959595"
									class="mr-3"
									@click="resolveRequest = false"
								>
									<v-icon dark>mdi-close</v-icon>
									<p class="ml-2 mb-0">Cancelar Cierre</p>
								</v-btn>
								<v-btn
									depressed
									dark
									@click="closeRequest(3)"
									color="green"
								>
									<v-icon dark>mdi-check</v-icon>
									<p class="ml-2 mb-0">Confirmar</p>
								</v-btn>
							</div>
							<div class="d-flex flex-row align-center justify-end" v-else>
								<v-btn
									depressed
									dark
									outlined
									color="#959595"
									class="mr-3"
									@click="$store.commit('userrequests/setUserRequestModalId', null)"
								>
									<v-icon dark>mdi-close</v-icon>
									<p class="ml-2 mb-0">Cancelar</p>
								</v-btn>
								<v-btn
									depressed
									dark
									outlined
									color="#FF120B"
									class="mr-3"
									@click="resolveRequest = true"
									v-if="!atLeastOneElement"
								>
									<v-icon dark>mdi-cancel</v-icon>
									<p class="ml-2 mb-0">Rechazar</p>
								</v-btn>
								<v-btn
									depressed
									dark
									outlined
									color="green"
									@click="acceptRequest"
									v-if="!atLeastOneElement"
								>
									<v-icon dark>mdi-check</v-icon>
									<p class="ml-2 mb-0">Aceptar</p>
								</v-btn>
								<!-- <v-btn
									depressed
									dark
									@click="resolveRequest = true"
									color="#959595"
								>
									<v-icon dark>mdi-check</v-icon>
									<p class="ml-2 mb-0">Cerrar Solicitud</p>
								</v-btn> -->
							</div>
						</div>
						<div class="mt-2 d-flex justify-end" v-else>
							<p class="mb-0 caption" v-if="userRequest.status < 2">En espera de revisión por parte del encargado</p>
						</div>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import {getUserRequestById, acceptRejectUserRequest} from '@/helpers/api/userrequests'
import {addElementToProjectLine} from '@/helpers/api/projectlines'
import { addContractAddendum } from '@/helpers/api/contracts'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

export default {
  name: 'UserRequestModal',
  data: () => ({
		indexModal: + new Date(),
		userRequest: null,
		loadingUserRequest: true,
		resolveForm: {
			status: 2,
			response: null
		},
		resolveStatuses: [
			{ id: 2, text: 'Aceptado' },
			{ id: 3, text: 'Rechazado' }
		],
		resolveRequest: false,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		isClient(){
			return this.$checkPermissions(['client_capabilities'])
		},
		associatedCrm() {
			if(this.userRequest.status == 2 && this.userRequest.project_line_associations){
				return this.userRequest.project_line_associations.find((item) => {
					return item.morphable_type == 'App\\Models\\BotConversation'
				})
			}
			return null
		},
		atLeastOneElement(){
			console.log('this.projectLineProject', this.projectLineProject)
			return this.projectLineCrm || this.projectLinePreProject || this.projectLineProject
		},
		projectTypeText(){
			const project = this.projectType
			if(project){
				return project.morphable?.info?.project_type?.name
			}
			return this.userRequest.project_type?.parent?.name + ' - ' + this.userRequest.project_type?.name
		},
		maxWidthDialog(){
			return this.resolveRequest ? 700:700
		},
		userRequestModalId(){
			return this.$store.state.userrequests.userRequestModalId
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		userInfo(){
			return this.userRequest ? this.userRequest.user : {}
		},
		projectType(){
			if(!this.userRequest){
				return null;
			}
			const hierarchy = {
				'App\\Models\\BotConversation': 1,
				'App\\Models\\PreProject': 2,
				'App\\Models\\Project': 3
			};
			const mostRelevant = this.userRequest.project_line_associations.reduce((highest, current) => {
				const currentLevel = hierarchy[current.morphable_type] || 0;
				const highestLevel = highest ? hierarchy[highest.morphable_type] || 0 : 0;

				return currentLevel > highestLevel ? current : highest;
			}, null);
			return mostRelevant;
		},
		requestProjectName(){
			const project = this.projectType
			if(this.userRequest?.project_line_associations.length > 0){
				return project?.morphable?.name ||  project?.morphable?.info?.project_detail || '--'
			}
			return '[Nuevo] ' + this.userRequest?.project_name || '--'
		},
		requestProjectAddress(){
			const project = this.projectType
			return project?.morphable?.info?.address?.address || this.userRequest?.address?.address || '--';
		},
		projectLineCrm(){
			return this.userRequest.project_line_associations.find((association) => {
				return association.morphable_type === 'App\\Models\\BotConversation'
			})
		},
		projectLinePreProject(){
			return this.userRequest.project_line_associations.find((association) => {
				return association.morphable_type === 'App\\Models\\PreProject'
			})
		},
		projectLineProject(){
			return this.userRequest.project_line_associations.find((association) => {
				return association.morphable_type === 'App\\Models\\Project'
			})
		}
	},
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
		this.getUserRequest()
  },
  methods: {
		goToCRM(crm_id){
			this.$router.push({ name: 'Conversation', params: { id: crm_id } })
			this.closeModal()
		},
		goToPreProject(pre_project_id){
			this.$router.push({ name: 'PreProject', params: { id: pre_project_id } })
			this.closeModal()
		},
		closeModal(){
			this.$store.commit('userrequests/setUserRequestModalId', null)
		},
		async getUserRequest(){
			this.loadingUserRequest = true
			const user_request = await getUserRequestById({user_request_id: this.userRequestModalId})
			this.loadingUserRequest = false
			if(user_request.code === 200){
				this.userRequest = user_request.user_request
			}
			else {
				this.$store.dispatch('general/addMessage', {
					message: 'Error al cargar la solicitud, por favor intenta nuevamente.',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				})
			}
		},
		async addNewElementToProjectLine(item_type){
			const pl = await addElementToProjectLine({
				project_line_id: this.userRequest.project_line_id,
				user_request_id: this.userRequest.id,
				item_type
			})
			if(item_type == 'crm' && pl.conversation){
				this.goToCRM(pl.conversation.id)
			}
			if(item_type == 'preproject' && pl.pre_project){
				this.goToPreProject(pl.pre_project.id)
			}
			this.getUserRequest()
		},
		async createReport(item_type, project){
			const item_name = project?.morphable?.name || project?.morphable?.info?.project_detail
			const data = {
				item_name,
				item_type,
				item_id: project.morphable_id
			}
			this.$store.commit('reports/setConfirmNewReportModal', data)
		},
		async createBudget(item_type, project){
			const item_name = project?.morphable?.name || project?.morphable?.info?.project_detail
			const data = {
				item_name,
				item_type,
				item_id: project.morphable_id
			}
			this.$store.commit('budget/setModalNewBudgetInfo', data)
			this.$store.commit('budget/setModalNewBudget', true)
		},
		async createContract(item_type, project){
			const item_name = project?.morphable?.name || project?.morphable?.info?.project_detail
			const data = {
				item_name,
				item_type,
				item_id: project.morphable_id
			}
			this.$store.commit('contracts/setModalContractInfo', data)
			this.$store.commit('contracts/setModalContract', true)
		},
		async createContractAddendum(){
			if(this.userRequest?.pl_signed_contract?.id){
				const data = {
					contract_id: this.userRequest?.pl_signed_contract?.id
				}
				const addendum = await addContractAddendum(data)
				if(addendum.code == 200){
					if(addendum.addendum_notsigned){
						const messageData = {
							message: 'Aún hay anexos pendientes de revisión, antes de iniciar un nuevo anexo todos los anteriores deben haber sido firmados o cancelados.',
							title: 'Anexos sin finalizar',
							type: 'danger',
							icon: 'mdi-close-octagon',
							color: '#FF1209',
						}
						this.setMessage(messageData)
						return null
					}
					this.closeModal()
					this.$router.push({ name: 'ContractAddendumDetail', query: { id: addendum.contract_addendum.id } })
					const messageData = {
						message: 'Se ha creado correctamente el anexo.',
						title: 'Anexo Creado',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.setMessage(messageData)
				}
				else{
					const messageData = {
						message: 'Hubo un error en la operación, por favor intenta nuevamente',
						title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
					}
					this.setMessage(messageData)
				}
			}
			else{
				const messageData = {
					message: 'No existe un contrato firmado por ambas partes para poder generar un anexo',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		acceptRequest(){
			if(this.userRequest?.project_line_associations.length == 0){
				this.addNewElementToProjectLine('crm')
				this.closeRequest(2)
			}
		},
		async closeRequest(status){
			// const data = {
			// 	...this.resolveForm,
			// 	...{user_request_id: this.userRequest.id}
			// }
			let response = status == 2 ? 'Se acepta solicitud':'Se rechaza solicitud'
			if(this.resolveForm.response){
				response = this.resolveForm.response
			}
			const data = {
				user_request_id: this.userRequest.id,
				status,
				response
			}
			const close_request = await acceptRejectUserRequest(data)
			if(close_request.code === 200){
				eventBus.$emit('reloadInformation')
				this.closeModal()
				const messageData = {
					message: 'Se ha modificado el estado de la solicitud y se ha notificado al cliente.',
					title: 'Solicitud cerrada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.$store.dispatch('general/addMessage', messageData)
			}
			else {
				this.$store.dispatch('general/addMessage', {
					message: 'Error al procesar la solicitud, por favor intenta nuevamente.',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				})
			}
		},
		editCrmSchedule(){
			const conversation = this.projectLineCrm?.morphable
			const userData = this.projectLineCrm?.morphable?.client
			let address = null
			let coordinates = null
			if(conversation?.info?.address?.address){
				address = conversation.info?.address?.address
				coordinates = conversation.info?.coordinates
			}
			this.$store.commit('schedule/setNewScheduleEditing', {
				title: 'Visita Técnica',
				user_name: userData?.profile?.name,
				user_email: userData?.email,
				user_phone: userData?.profile?.phone,
				lastname: userData?.profile?.lastname,
				second_lastname: userData?.profile?.second_lastname,
				crm_id: conversation.id,
				address: {address, coordinates},
				to_crm: true
			})
			this.$store.commit('schedule/setNewScheduleModal', true)
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
	.custom-toggle-btns .v-btn--active:before{
		opacity: 0;
	}
	.type-container{
		border-radius: 10px;
		border: 1px solid #E5E9F2;
	}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>